import React, { useEffect, useState } from 'react';
import { collection, setDoc, deleteDoc, doc, onSnapshot, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { db } from '../../firebase';
import { initializeApp, getApps } from 'firebase/app';
import { TextField, Button, Select, MenuItem, Typography, Grid, InputLabel, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableHead, TableRow, TableCell, TableBody, Paper, IconButton, CircularProgress, Box, InputAdornment, TableContainer } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Alerts from '../../components/Alerts';

const firebaseConfig = {
  apiKey: "AIzaSyCo7LYZdP4Ql9OIiIU-zo-Dvf4Tq7R2suk",
  authDomain: "restaurant-management-sy-372c7.firebaseapp.com",
  projectId: "restaurant-management-sy-372c7",
  storageBucket: "restaurant-management-sy-372c7.firebasestorage.app",
  messagingSenderId: "633215899866",
  appId: "1:633215899866:web:74a5deeb10038d39616de3",
  measurementId: "G-9XCKGEREMK"
};

const AddUser = ({ darkMode, companyCode }) => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('kitchen_staff');
  const [selectedUnitCode, setSelectedUnitCode] = useState('');
  const [users, setUsers] = useState([]);
  const [units, setUnits] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingPassword, setEditingPassword] = useState('');
  const [search, setSearch] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null });
  const [loading, setLoading] = useState(true);
  //const auth = getAuth();
  const [serviceAreas, setServiceAreas] = useState([]);
const [selectedServiceArea, setSelectedServiceArea] = useState('');
const [allServiceAreas, setAllServiceAreas] = useState({});
useEffect(() => {
  if (!companyCode) return;

  const q = query(
    collection(db, "serviceAreas"),
    where("companyCode", "==", companyCode)
  );

  const unsub = onSnapshot(q, (snapshot) => {
    const map = {};
    snapshot.docs.forEach(doc => {
      map[doc.id] = doc.data().serviceAreaName;
    });

    setAllServiceAreas(map);
  });

  return () => unsub();
}, [companyCode]);

useEffect(() => {
  if (!selectedUnitCode || !companyCode) {
    setServiceAreas([]);
    return;
  }

 const q = query(
  collection(db, "serviceAreas"),
  where("companyCode", "==", companyCode),
  where("unitCode", "==", selectedUnitCode)
);

  const unsub = onSnapshot(q, (snapshot) => {
    const areas = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setServiceAreas(areas);
  });

  return () => unsub();
}, [selectedUnitCode, companyCode]);

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const getSecondaryApp = () => {
    const appName = 'userCreationApp';
    const existingApp = getApps().find(app => app.name === appName);
    return existingApp || initializeApp(firebaseConfig, appName);
  };

  const handleAddUser = async () => {
    if (!companyCode) {
      showSnackbar('Company code is missing', 'error');
      return;
    }
    if (!userId || !password) {
      showSnackbar('User ID and Password are required', 'warning');
      return;
    }
    if (!selectedUnitCode) {
      showSnackbar('Unit is required', 'warning');
      return;
    }
    if (userId.includes('#')) {
      showSnackbar('User ID cannot contain "#"', 'warning');
      return;
    }

    if (role === "servers" && !selectedServiceArea) {
  showSnackbar('Service Area is required for server role', 'warning');
  return;
}
    const prefixedUserId = `${selectedUnitCode}#${userId}`;
    const pseudoEmail = `${prefixedUserId}@platterly.in`;
    try {
      const usersQuery = query(
        collection(db, 'users'),
        where('userId', '==', prefixedUserId),
        where('companyCode', '==', companyCode)
      );
      const querySnapshot = await getDocs(usersQuery);
      if (!querySnapshot.empty) {
        showSnackbar('User ID already exists for this company', 'error');
        return;
      }

      const secondaryApp = getSecondaryApp();
      const secondaryAuth = getAuth(secondaryApp);
      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, pseudoEmail, password);
      const user = userCredential.user;

      await setDoc(doc(db, 'users', user.uid), {
        userId: prefixedUserId,
        role,
        companyCode: companyCode,
        unitCode: selectedUnitCode,
        serviceArea: role === "servers" ? selectedServiceArea : "",
        createdTime: new Date().toISOString(),
        uid: user.uid,
      });

      await signOut(secondaryAuth);

      setUserId('');
      setPassword('');
      setSelectedUnitCode('');
      setSelectedServiceArea('');
      showSnackbar('User added successfully');
    } catch (error) {
      console.error('Error adding user:', error);
      showSnackbar(`Failed to add user: ${error.message}`, 'error');
    }
  };

  useEffect(() => {
    if (!companyCode) {
      console.error('AddUser: No companyCode provided');
      setLoading(false);
      return;
    }

    const usersQuery = query(
      collection(db, 'users'),
      where('companyCode', '==', companyCode)
    );
    const unsubUsers = onSnapshot(usersQuery, (snapshot) => {
      const allUsers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(allUsers);
      console.log(`AddUser: Fetched ${allUsers.length} users for companyCode: ${companyCode}`);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching users:', error);
      showSnackbar('Failed to fetch users', 'error');
      setLoading(false);
    });

    const unitsQuery = query(
      collection(db, 'units'),
      where('companyCode', '==', companyCode)
    );
    const unsubUnits = onSnapshot(unitsQuery, (snapshot) => {
      const allUnits = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUnits(allUnits);
      console.log(`AddUser: Fetched ${allUnits.length} units for companyCode: ${companyCode}`);
    }, (error) => {
      console.error('Error fetching units:', error);
      showSnackbar('Failed to fetch units', 'error');
    });

    return () => {
      unsubUsers();
      unsubUnits();
    };
  }, [companyCode]);

  const handleDeleteConfirm = async () => {
    const { id } = deleteDialog;
    try {
      await deleteDoc(doc(db, 'users', id));
      showSnackbar('User deleted from Firestore. Delete from Authentication via Firebase Console.', 'warning');
    } catch (error) {
      console.error('Error deleting user:', error);
      showSnackbar('Failed to delete user', 'error');
    } finally {
      setDeleteDialog({ open: false, id: null });
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteDialog({ open: true, id });
  };

  const handleEdit = (id) => {
    setEditingId(id);
    setEditingPassword('');
  };

  const handleSave = async (id) => {
    try {
      if (!editingPassword) {
        showSnackbar('New password is required', 'warning');
        return;
      }
      showSnackbar('Password update requires Firebase Console. Metadata updated.', 'warning');
      await updateDoc(doc(db, 'users', id), {
        updatedTime: new Date().toISOString(),
      });
      setEditingId(null);
      setEditingPassword('');
    } catch (error) {
      console.error('Error updating user:', error);
      showSnackbar(`Failed to update user: ${error.message}`, 'error');
    }
  };

  const filteredUsers = users.filter(user => {
    const userIdPart = user.userId.split('#')[1] || '';
    return userIdPart.toLowerCase().includes(search.toLowerCase());
  });

  const prefixText = selectedUnitCode ? `${selectedUnitCode}#` : 'unit#';

  return (
    <Box sx={{ padding: 3, maxWidth: '1300px', margin: 'auto' }}>
      <Typography variant="h5" gutterBottom color="text.primary">
        Add User
      </Typography>
      <Grid container spacing={2} sx={{ marginBottom: 5 }}>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="User ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            InputLabelProps={{ style: { color: 'text.secondary' } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography
                    sx={{
                      color: 'text.disabled',
                      fontWeight: 'medium',
                      userSelect: 'none'
                    }}
                  >
                    {prefixText}
                  </Typography>
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiInputBase-input': { color: 'text.primary' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'text.secondary' },
                '&:hover fieldset': { borderColor: 'primary.main' },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputLabelProps={{ style: { color: 'text.secondary' } }}
            sx={{
              '& .MuiInputBase-input': { color: 'text.primary' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'text.secondary' },
                '&:hover fieldset': { borderColor: 'primary.main' },
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel sx={{ color: 'text.secondary' }}>Unit</InputLabel>
            <Select
              label="Unit"
              value={selectedUnitCode}
              onChange={(e) => setSelectedUnitCode(e.target.value)}
              sx={{
                color: 'text.primary',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
              }}
            >
              {units.map((unit) => (
                <MenuItem key={unit.id} value={unit.unitCode}>
                  {unit.unitCode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel sx={{ color: 'text.secondary' }}>Role</InputLabel>
            <Select
              label="Role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              sx={{
                color: 'text.primary',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
              }}
            >
              <MenuItem value="kitchen_staff">Kitchen Staff</MenuItem>
              <MenuItem value="servers">Servers</MenuItem>
              <MenuItem value="unit_manager">Unit Manager</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {role === "servers" && (
  <Grid item xs={12} sm={5}>
    <FormControl fullWidth>
      <InputLabel>Service Area</InputLabel>
      <Select
        value={selectedServiceArea}
        onChange={(e) => setSelectedServiceArea(e.target.value)}
        label="Service Area"
      >
        {serviceAreas.map(area => (
          <MenuItem key={area.id} value={area.id}>
            {area.serviceAreaName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)}
        <Grid item xs={12} sm={2}>
          <Button variant="contained" onClick={handleAddUser} sx={{ height: '100%', width: '120px' }}>
            Add
          </Button>
        </Grid>
      </Grid>

      <Typography variant="h5" gutterBottom color="text.primary">
        User List
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper
          sx={{
            borderRadius: 3,
            boxShadow: 4,
            overflowX: 'auto',
            bgcolor: 'background.paper',
          }}
        >
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={6} sx={{ bgcolor: 'custom.cardSecondary' }}>
                    <TextField
                      label="Search by User ID (without unit prefix)"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      InputLabelProps={{ style: { color: 'text.secondary' } }}
                      sx={{
                        '& .MuiInputBase-input': { color: 'text.primary' },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: 'text.secondary' },
                          '&:hover fieldset': { borderColor: 'primary.main' },
                        },
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', bgcolor: 'background.paper', py: 2, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    S.No
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', bgcolor: 'background.paper', py: 2, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    User ID
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', bgcolor: 'background.paper', py: 2, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    Role
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', bgcolor: 'background.paper', py: 2, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    Unit
                  </TableCell>
                  <TableCell
  sx={{
    fontWeight: 'bold',
    color: 'text.primary',
    bgcolor: 'background.paper'
  }}
>
  Service Area
</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold', color: 'text.primary', bgcolor: 'background.paper', py: 1, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.map((user, index) => (
                  <TableRow
                    key={user.id}
                    sx={{
                      bgcolor: index % 2 === 0 ? 'custom.cardSecondary' : 'background.paper',
                    }}
                  >
                    <TableCell sx={{ py: 2, fontSize: { xs: '0.75rem', sm: '0.875rem' }, color: 'text.primary', minWidth: { xs: '50px', sm: '60px' } }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ py: 2, fontSize: { xs: '0.75rem', sm: '0.875rem' }, color: 'text.primary', minWidth: { xs: '100px', sm: '150px' } }}>
                      {user.userId}
                    </TableCell>
                    <TableCell sx={{ py: 1, fontSize: { xs: '0.75rem', sm: '0.875rem' }, color: 'text.primary', minWidth: { xs: '80px', sm: '100px' } }}>
                      {user.role}
                    </TableCell>
                    <TableCell sx={{ py: 1, fontSize: { xs: '0.75rem', sm: '0.875rem' }, color: 'text.primary', minWidth: { xs: '80px', sm: '100px' } }}>
                      {user.unitCode || '-'}
                    </TableCell>
                    <TableCell
  sx={{
    py: 1,
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    color: 'text.primary'
  }}
>
 {allServiceAreas[user.serviceArea] || '-'}
</TableCell> 
                    <TableCell align="right" sx={{ py: 1, minWidth: { xs: '80px', sm: '100px' } }}>
                      <IconButton
                        onClick={() => editingId === user.id ? handleSave(user.id) : handleEdit(user.id)}
                        size="small"
                      >
                        {editingId === user.id ? <SaveIcon fontSize="small" /> : <EditIcon fontSize="small" />}
                      </IconButton>
                      <IconButton onClick={() => handleDeleteClick(user.id)} size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      <Dialog open={editingId !== null} onClose={() => { setEditingId(null); setEditingPassword(''); }}>
        <DialogTitle>Edit Password</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="New Password"
            type="password"
            value={editingPassword}
            onChange={(e) => setEditingPassword(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setEditingId(null); setEditingPassword(''); }}>Cancel</Button>
          <Button onClick={() => handleSave(editingId)}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, id: null })}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this user? You must also delete the user from Firebase Authentication via the Firebase Console.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, id: null })}>Cancel</Button>
          <Button color="error" onClick={handleDeleteConfirm}>Delete</Button>
        </DialogActions>
      </Dialog>

      <Alerts
        snackbar={snackbar}
        handleClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        darkMode={darkMode}
      />
    </Box>
  );
};

export default AddUser;